export default __webpack_public_path__ + "static/media/wallpaper_bg5.7c0f6d9b.png";